import React, {useEffect, useState} from 'react';

import { renderDropdown, renderDropdownReadOnly} from "./DropdownFunctions";

import SpinnerDiv from "./SpinnerDiv";
import PropTypes from "prop-types";
import {getTransitions} from "ui/DropdownDataProviders";

const DropdownTransitions = ( props ) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        getTransitions().then (response =>
        {
            setData ( { loading: false, items: response }) ;
        })
    }, []);

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props, data) : renderDropdown(props, data)
    )
}

export default DropdownTransitions;

DropdownTransitions.defaultProps =
{
    defaultClassName: 'form-group'
}

DropdownTransitions.propTypes = {
    onChange: PropTypes.func.isRequired
};